<template>
  <div
    :class="backgroundColorClass(fields.backgroundColor)"
    class="content-center"
  >
    <ctf-rich-text  v-if="!fields.mediaBg && !fields.mediaXs"
      class="d-flex justify-center align-center text-center content-banner content-constraint mx-auto"
      :class="[
        { 'white--text': fields.backgroundColor === 'dark blue' || fields.backgroundColor === 'blue' }
      ]"
      :document="fields.body" />
    <div
      v-else
      class="d-flex justify-center content-constraint"
    >
      <!-- this extra div fixes flex layout issues in safari -->
      <div>
        <video
          v-if="assetUrlBg"
          class="video-media-content"
          :controls="false"
          autoplay
          playsinline
          muted
        >
          <source
            :src="assetUrlBg"
            type="video/mp4"
          >
        </video>
      </div>
    </div>
    <!--    <div-->
    <!--      v-if="fields.animatedFadeIn && timerComplete"-->
    <!--      class="d-flex align-center bcbs-content"-->
    <!--      :class="[-->
    <!--        { 'flex-column': smAndDown }-->
    <!--      ]"-->
    <!--    >-->
    <!--      <div class="animated-enter-left white&#45;&#45;text white-space-no-wrap">Whatever your</div>-->
    <!--      <div class="animated-bounce-in block-content d-inline white text-center mx-3">Next</div>-->
    <!--      <div class="animated-enter-right white&#45;&#45;text white-space-no-wrap">this is your plan</div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { backgroundColorClass } from '@/utils/helpers'
import { BLOCKS } from '@contentful/rich-text-types'
import { getCTFAsset } from '@/plugins/contentful'

export default {
  name: 'ContentBanner',
  props: {
    fields: {
      type: Object,
      required: true
    },
    assets: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      documentOptions: {
        renderNode: {
          [BLOCKS.PARAGRAPH]: (node) => {
            // TODO: make it so the text can be custom w/ the animations
            // let str = node.content[0].value
            // if (str.includes('<block>')) {
            //   str = str.replace('<block>', '')
            //   const start = str.indexOf('[')
            //   const end = str.indexOf(']')
            //   const blockContent = `
            //     <div class="animated-bounce-in block-content d-inline white primary--text text-center">${str.substr(start + 1, end - start - 1)}</div>
            //   `
            //   return `
            //     <span class="animated-enter-left white-space-no-wrap">${str.substr(0, start)}</span>
            //     ${(this.smAndDown) ? '<br>' : ''}
            //     ${blockContent}
            //     ${(this.smAndDown) ? '<br>' : ''}
            //     <span class="animated-enter-right white-space-no-wrap">${str.substr(end + 1, str.length)}</span>
            //   `
            // }
            // return documentToHtmlString(this.fields.body)
          }
        }
      },
      timerComplete: false,
      assetUrlBg: ''
    }
  },
  computed: {
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  created () {
    // originally was setting a timeout before displaying the css animation
    // setTimeout(() => {
    //   this.timerComplete = true
    // }, 1 * 1000)
    if (this.fields.mediaBg) {
      const videoBg = getCTFAsset(this.fields.mediaBg.sys.id, this.assets)
      this.assetUrlBg = videoBg.fields.file.url
    }
  },
  methods: {
    backgroundColorClass
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/styles/variables';
  .content-banner {
    width: 100%;
    position: relative;
    z-index: 1;
    min-height: 150px;
  }
  .video-media-content {
    height: 100%;
    width: 100%;
  }
</style>
